export const PRE_FETCH_ICONS = {
  CONTAINER: 'pre-fetch-icons-container',
  ICON_PLACEHOLDER: 'pre-fetch-icons-icon-placeholder'
} as const;
